import Cookie from 'js-cookie';

const lead = {
  namespaced: true,
  state: {
    leadFilled: false,
  },
  mutations: {
    SET_LEAD_FILLED(state, data) {
      Cookie.set('gabarito-lead', !this.leadFilled);
      Object.assign(state, {
        leadFilled: data,
      });
    },
  },
  actions: {
    setLeadFilled({ commit }, data) {
      return commit('SET_LEAD_FILLED', data);
    },
  },
};

export default lead;
